import { ILookupResult } from '../../shared-types';

interface IFundHistoryCacheEntry {
  items: ILookupResult[];
}

interface IFundHistoryCacheOptions {
  keySuffix?: string;
  keyPrefix?: string;
  cacheExpiryInMinute?: number;
}

export default class FundHistoryCache {
  private options: IFundHistoryCacheOptions = {
    keySuffix: '',
    keyPrefix: '.fhc_',
    cacheExpiryInMinute: 5,
  };
  public constructor(options: IFundHistoryCacheOptions) {
    Object.assign(this.options, options);
  }

  public get(): ILookupResult[] {
    return findFundHistoryCacheEntry(this.makeKey()) || [];
  }

  public set(items: ILookupResult[]) {
    const itemsToStore = items.map((item) => {
      // eslint-disable-next-line id-blacklist
      item.lastUsed = item.lastUsed === undefined ? null : item.lastUsed;
      return item;
    });
    cacheFundHistoryResults(this.makeKey(), itemsToStore);
  }

  public flush() {
    const key = this.makeKey();
    Object.keys(localStorage)
      .filter((s) => s === key)
      .forEach((s) => {
        localStorage.removeItem(s);
      });
  }

  private makeKey() {
    const { keyPrefix, keySuffix } = this.options;
    return `${keyPrefix}_${keySuffix}`;
  }
}

export function tryParseFundHistoryCacheEntry(
  cacheEntryJson: string
): IFundHistoryCacheEntry | null {
  try {
    return JSON.parse(cacheEntryJson);
  } catch {
    return null;
  }
}

export function findFundHistoryCacheEntry(key: string): ILookupResult[] | null {
  const cachedJson = localStorage.getItem(key);
  if (!cachedJson) {return null;}
  const cachedEntry = tryParseFundHistoryCacheEntry(cachedJson);
  if (!cachedEntry) {return null;}

  return cachedEntry.items;
}

export function cacheFundHistoryResults(key: string, items: ILookupResult[]) {
  const cacheEntry: IFundHistoryCacheEntry = { items };

  localStorage.setItem(key, JSON.stringify(cacheEntry));
}
